import Action from 'ageas-react-component-action'
import PageTitle from 'ageas-react-component-pagetitle'

import { useSimulatorStore } from '../../../Stores/simulatorStore'
import { t } from '../../../i18n'
import { ReportDialog } from '../styles'

type Props = {
  onCancel: () => void
  onClick: () => void
  disabled?: boolean
}

export const ReportAdditionalDocumentsRequired = ({
  onCancel,
  onClick,
  disabled,
}: Props) => {
  const { quoteId } = useSimulatorStore()

  return (
    <ReportDialog>
      <PageTitle
        bar={false}
        id="ReportAdditionalDocumentsRequiredTitle"
        name={t('pages.step5.reportAdditional.title')}
      />
      <p className="text">{t('pages.step5.reportAdditional.description')}</p>
      <p className="text">
        {t('pages.step5.reportAdditional.simulationId')}{' '}
        <strong>{quoteId}</strong>
      </p>
      <div className="group-buttons">
        <Action
          id="contactCancel"
          label={t('pages.step5.reportAdditional.cancel')}
          type="button"
          buttonType="secondary"
          disable={disabled}
          onValueChanged={onCancel}
        />
        <Action
          id="contactCreate"
          label={t('pages.step5.reportAdditional.continue')}
          type="button"
          disable={disabled}
          onValueChanged={onClick}
        />
      </div>
    </ReportDialog>
  )
}
